import React from "react";
import { DANDU_INSTAGRAM_URL } from '../parent/theme';

const COMPANY_NAME = 'DANDU Yazılım ve Yapay Zeka Teknolojileri Limited Şirketi';
const COMPANY_ADDRESS = 'Yalova Teknopark, Laledere Köyü Merkez Mevkii Mustafa Varank Cad. Çarşı No: 12C, Çiftlikköy / Yalova';

export default function LegalFooter({ variant = 'default' }) {
  if (variant === 'student') {
    return (
      <footer role="contentinfo" aria-label="DANDU iletişim ve yasal bilgiler" style={{
        marginTop:24, padding:'22px 16px 26px', background:'#eaf5f8', borderTop:'1px solid #cfe8ed',
        color:'#455675', fontSize:12, lineHeight:1.55,
      }}>
        <strong style={{ display:'block', color:'#0f1e56', fontSize:17, fontWeight:900 }}>DANDU</strong>
        <div style={{ marginTop:5, fontWeight:800 }}>{COMPANY_NAME}</div>
        <address style={{ marginTop:3, fontStyle:'normal' }}>{COMPANY_ADDRESS}</address>
        <nav aria-label="İletişim" style={{ display:'flex', flexWrap:'wrap', gap:'8px 18px', marginTop:14 }}>
          <a href="tel:+905333961428" style={studentLinkStyle}>+90 533 396 14 28</a>
          <a href="mailto:info@dandu.com.tr" style={studentLinkStyle}>info@dandu.com.tr</a>
          <a href={DANDU_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" style={studentLinkStyle}>Instagram</a>
        </nav>
        <nav aria-label="Yasal bağlantılar" style={{ display:'flex', flexWrap:'wrap', gap:'8px 16px', marginTop:12 }}>
          <a href="/legal/privacy.html" style={studentLinkStyle}>KVKK Aydınlatma Metni</a>
          <a href="/legal/terms.html" style={studentLinkStyle}>Kullanım Şartları</a>
          <a href="/legal/delete-data.html" style={studentLinkStyle}>Veri Silme</a>
        </nav>
        <div style={{ marginTop:16, paddingTop:10, borderTop:'1px solid #d4e5eb', color:'#64748b' }}>
          © {new Date().getFullYear()} DANDU
        </div>
      </footer>
    );
  }

  return (
    <footer
      role="contentinfo"
      aria-label="Yasal Bilgiler"
      style={{
        marginTop: "64px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        padding: "24px 0",
        fontSize: "0.9rem",
        lineHeight: 1.6,
        color: "rgba(255,255,255,0.75)"
      }}
    >
      <section id="yasal-bilgiler" style={{maxWidth: 1200, margin: "0 auto", padding: "0 16px"}}>
        <strong style={{color: "rgba(255,255,255,0.9)"}}>Yasal Bilgiler</strong><br />
        {COMPANY_NAME}<br />
        Adres: {COMPANY_ADDRESS}
      </section>
    </footer>
  );
}

const studentLinkStyle = { color:'#1e40af', fontWeight:800, textDecoration:'none' };

